/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/crm-fetch-client";
import type { DeleteContactMutationResponse, DeleteContactPathParams, DeleteContactHeaderParams, DeleteContact401 } from "../../models/contactsController/DeleteContact";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/crm-fetch-client";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteContactMutationKey = () => [{ url: '/contacts/:contactId' }] as const

export type DeleteContactMutationKey = ReturnType<typeof deleteContactMutationKey>

/**
 * {@link /contacts/:contactId}
 */
export async function deleteContact(contactId: DeleteContactPathParams["contactId"], headers?: DeleteContactHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteContactMutationResponse, ResponseErrorConfig<DeleteContact401>, unknown>({ method : "DELETE", url : `/contacts/${contactId}`, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function deleteContactMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = deleteContactMutationKey()
        return mutationOptions<DeleteContactMutationResponse, ResponseErrorConfig<DeleteContact401>, {contactId: DeleteContactPathParams["contactId"], headers?: DeleteContactHeaderParams}, TContext>({
          mutationKey,
          mutationFn: async({ contactId, headers }) => {
            return deleteContact(contactId, headers, config)
          },
        })

}

/**
 * {@link /contacts/:contactId}
 */
export function useDeleteContact<TContext>(options: 
{
  mutation?: UseMutationOptions<DeleteContactMutationResponse, ResponseErrorConfig<DeleteContact401>, {contactId: DeleteContactPathParams["contactId"], headers?: DeleteContactHeaderParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? deleteContactMutationKey()

          const baseOptions = deleteContactMutationOptions(config) as UseMutationOptions<DeleteContactMutationResponse, ResponseErrorConfig<DeleteContact401>, {contactId: DeleteContactPathParams["contactId"], headers?: DeleteContactHeaderParams}, TContext>
          

          return useMutation<DeleteContactMutationResponse, ResponseErrorConfig<DeleteContact401>, {contactId: DeleteContactPathParams["contactId"], headers?: DeleteContactHeaderParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DeleteContactMutationResponse, ResponseErrorConfig<DeleteContact401>, {contactId: DeleteContactPathParams["contactId"], headers?: DeleteContactHeaderParams}, TContext>
      
}